{
  "title": "Launchpad de Salt",
  "subtitle": "Nous aurons plus pour vous plus tard."
}
